import { render } from "./PopUp.vue?vue&type=template&id=d563c14c"
import script from "./PopUp.vue?vue&type=script&lang=js"
export * from "./PopUp.vue?vue&type=script&lang=js"

import "./PopUp.vue?vue&type=style&index=0&id=d563c14c&lang=css"

import exportComponent from "/home/luis/dev/nyxhotel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__